// extracted by mini-css-extract-plugin
var _1 = "DocFlowProfileHeaderContent-modulephase__hQWO0 EntityPhaseItem-moduleEntityPhaseItem__skgCK";
var _2 = "DocFlowProfileHeaderContent-modulephases__OKFyn EntityPhaseList-moduleEntityPhaseList__JbnjJ";
export { _1 as "phase", _2 as "phases" }
